import React, { useEffect, useState } from "react";
import LoaderStyleOne from "../../../components/LoaderStyleOne";
import {
  Box,
  Typography,
  Button,
  Grid,
  Tabs,
  Tab,
  TextField,
  IconButton,
  Chip,
} from "@mui/material";
import { getData, postData } from "../../../ServerRequest";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import LandscapeIcon from "@mui/icons-material/Landscape";
import DetailDropdowns from "./DetailDropdowns";

export default function ProductDetail() {
  const searchParams = new URLSearchParams(window.location.search);
  const productId = searchParams.get("product_id");
  const [loading, setLoading] = useState(true);
  const [selectedImage, setSelectedImage] = useState(null);
  const [editingImageUrl, setEditingImageUrl] = useState("");
  const [isEditing, setIsEditing] = useState(false);
  const [images, setImages] = useState([]);
  const [formData, setFormData] = useState({
    ps_product_ID: "",
    ps_product_productcode: "",
    ps_product_cat: "",
    ps_product_productdesc: "",
    ps_product_prodname: "",
    ps_product_count: "",
    ps_product_construction: "",
    ps_product_width: "",
    ps_product_mill: "",
    updated_on: "",
    ps_product_productimg: "",
    ps_product_prodwho: null,
    ps_product_desc: null,
    ps_product_sellrate1: null,
    ps_product_sellrate2: null,
    ps_product_sellrate3: null,
    ps_product_subcat: "",
    ps_product_composition: "",
    ps_product_size: null,
    ps_product_style: "",
    ps_product_quality: null,
    ps_product_type: null,
    ps_product_pattern: null,
    ps_product_shade: null,
    ps_product_color1: null,
    ps_product_color2: "",
    ps_product_color3: null,
    ps_product_color4: "",
    ps_product_color5: "",
    ps_product_purchaserate1: null,
    ps_product_purchaserate2: null,
    ps_product_purchaserate3: null,
    ps_product_createdttime: "",
    ps_product_modifydttime: "",
    ps_product_QQH: null,
    ps_product_SO: null,
    ps_product_IQ: null,
    ps_product_DC: null,
    ps_product_DCvalue: null,
    ps_product_DCqty: null,
    ps_product_rcptqty: null,
    ps_product_issueqty: null,
    ps_product_lastsellrate: null,
    ps_product_COMM: null,
    ps_product_netqty: null,
    ps_product_dim1: "",
    ps_product_dim2: "",
    ps_product_dim3: "",
    ps_product_dim4: "",
    ps_product_dim5: "",
    ps_product_instock: null,
    ps_product_likes: null,
    ps_product_tags: null,
    ps_product_tags2: null,
    ps_product_excelpath: null,
    ps_product_isimgdone: null,
    ps_product_tags3: null,
    ps_product_image_modifydttime: null,
    ps_product_isnull_checked: null,
    ps_product_is_nos: null,
    ps_product_status: "",
    added_on: "",
    ps_product_gsm: "",
    ps_product_inventory: "",
    //ps_product_gsm: '',
    //ps_product_inventory: '',
  });
  const [selectedTab, setSelectedTab] = useState(0);
  const [fabricImages, setFabricImages] = useState([
    "fabric1.jpg",
    "fabric2.jpg",
    "fabric3.jpg",
    "fabric4.jpg",
    "fabric5.jpg",
    "fabric6.jpg",
  ]);
  const [garmentImages, setGarmentImages] = useState([
    "garment1.jpg",
    "garment2.jpg",
    "garment3.jpg",
    "garment4.jpg",
    "garment5.jpg",
    "garment6.jpg",
  ]);
  const [imageSizing, setImageSizing] = useState([
    "size1.jpg",
    "size2.jpg",
    "size3.jpg",
  ]);

  const handleProductSubmit = async (event) => {
    console.log(formData);
    setLoading(true);
    event.preventDefault();
    let productReqData = {
      ps_product_ID: formData.ps_product_ID ? formData.ps_product_ID : "",
      ps_product_productcode: formData.ps_product_productcode,
      ps_product_cat: formData.ps_product_cat,
      ps_product_productdesc: formData.ps_product_productdesc,
      ps_product_prodname: formData.ps_product_prodname,
      ps_product_count: formData.ps_product_count,
      ps_product_construction: formData.ps_product_construction,
      ps_product_width: formData.ps_product_width,
      ps_product_mill: formData.ps_product_mill,
      //'ps_product_pattern': formData.ps_product_pattern,
      //'ps_product_gsm': formData.ps_product_gsm,
      //'ps_product_inventory': formData.ps_product_inventory,
    };

    const convertToBase64 = (file) => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    };

    if (
      formData.ps_product_productimg &&
      formData.ps_product_productimg instanceof Blob
    ) {
      productReqData.ps_product_productimg = await convertToBase64(
        formData.ps_product_productimg
      );
    } else if (isEditing && editingImageUrl) {
      productReqData.ps_product_productimg = editingImageUrl;
    }
    console.log(productReqData);

    try {
      let productResData = await postData("/api/product/all", productReqData);
      if (productResData["data"]["code"] === "200") {
        alert("Product saved successfully.");
        if (isEditing) {
          setImages(
            images.map((image) =>
              image.id === selectedImage.id ? formData : image
            )
          );
        } else {
          const newimage = { ...formData, id: images.length + 1 };
          setImages([...images, newimage]);
        }
        setLoading(false);
      } else {
        alert("Error saving product. Please try again.");
      }
    } catch (error) {
      console.error("Error saving product:", error);
    }
  };

  useEffect(() => {
    async function fetchformData() {
      try {
        let resData = await getData(
          "/api/product/get-product?product_id=" + productId
        );
        console.log(resData);
        let product_data = resData["data"]["product"];
        if (product_data) {
          console.log(product_data);
          const imageUrls = product_data.ps_product_productimg
            ? product_data.ps_product_productimg.split(",")
            : [];
          const resizedImageUrls = product_data.ps_product_resizedimg
            ? product_data.ps_product_resizedimg.split(",")
            : [];
            console.log(imageUrls);
          setFabricImages(imageUrls);

          const savedfabricImages = imageUrls
            .filter((url) => /_\d+\.(jpg|jpeg)$/i.test(url))
            .map(
              (url) =>
                `https://ambikaproduct.s3.ap-south-1.amazonaws.com/${url}`
            );
          // // const savedgarmentImages = imageUrls
          // //     .filter(url => /_2_(small|medium|large|xlarge)\.jpeg$/.test(url))
          // //     .map(url => `https://ambikaproduct.s3.ap-south-1.amazonaws.com/${url}`);
          const savedsizingImages = resizedImageUrls
            .filter((url) => /_(small|medium|large|xlarge)\.(jpg|jpeg)$/i.test(url))
            .map(
              (url) =>
                `https://ambikaproduct.s3.ap-south-1.amazonaws.com/${url}`
            );

          console.log(savedsizingImages);

          setFabricImages(savedfabricImages);
          // setGarmentImages(savedgarmentImages);
          setImageSizing(savedsizingImages);
          if (product_data) {
            setFormData(product_data);
            console.log(formData);
          }
        } else {
          console.error("Error fetching product data:", resData.message);
        }
        setLoading(false);
      } catch (error) {
        console.error("Error in fetchformData:", error);
        setLoading(false);
      }
    }
    fetchformData();
  }, []);

  const handleToggleEdit = () => {
    setIsEditing((prev) => !prev);
  };

  const TabPanel = ({ value, index, children }) => {
    return (
      <Box role="tabpanel" hidden={value !== index} sx={{ mt: 4, mb: 4 }}>
        {value === index && <Typography>{children}</Typography>}
      </Box>
    );
  };

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  const handleDateChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
      ps_product_dateUpdated: new Date().toISOString().split("T")[0], // YYYY-MM-DD format
    }));
  };

  return (
    <Box sx={{ width: "95%", paddingLeft: 3 }}>
      {loading ? (
        <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: 300 }}>
          <LoaderStyleOne />
        </Box>
      ) : (
        <Box
          sx={{
            border: "0px solid #ccc",
            borderRadius: "0px",
            padding: 2,
            maxWidth: "1200px",
            margin: "0 auto",
          }}
        >
          <Typography
            variant="body1"
            sx={{
              mb: 2,
              fontWeight: 700,
              fontSize: "16px",
              fontFamily: "Inter, sans-serif",
              color: "#171A1F",
            }}
          >
            General information
          </Typography>

          {/* 1ST Part */}
          <Grid
            container
            sx={{
              backgroundColor: "#F8F9FA",
              border: "1px solid #F3F4F6",
              padding: 2,
              borderRadius: "0px",
              maxWidth: "1210px",
            }}
          >
            {/* Product Image with Placeholder */}
            <Grid item xs={12} sm={4}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "240px",
                  border: "1px solid #F3F4F6",
                  borderRadius: "0px",
                  backgroundColor: "white",
                  overflow: "hidden",
                }}
                style={{ marginRight: 25, marginLeft: 10, marginTop: 10 }}
              >
                {formData.ps_product_productimg ? (
                  <img
                    src={`https://ambikaproduct.s3.ap-south-1.amazonaws.com/${formData.ps_product_productimg.split(",")[0].trim()}`}
                    alt="Product"
                    style={{ width: "100%", height: "100%", objectFit: "cover" }}
                  />
                ) : (
                  <LandscapeIcon fontSize="large" sx={{ color: "#BCC1CA" }} />
                )}
              </Box>
            </Grid>

            {/* Input Fields */}
            <Grid item xs={12} sm={8}>
              <Grid container spacing={2}>
                {/* Header Inputs */}
                <Grid
                  item
                  xs={12}
                  sx={{
                    display: "flex",
                    gap: 2,
                    flexWrap: { xs: "wrap", md: "nowrap" },
                    flexDirection: { xs: "column", md: "row" },
                  }}>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      flex: 1,
                      mb: 2,
                      minWidth: 0,
                      width: "100%",
                      flexDirection: { xs: "column", md: "row" },
                      gap: { xs: 1, md: 0 },
                    }}
                  >
                    <label
                      htmlFor="productCode"
                      style={{
                        width: "120px",
                        minWidth: "120px",
                        fontWeight: 400,
                        fontSize: "16px",
                        fontFamily: "Inter, sans-serif",
                      }}
                    >
                      Product code :
                    </label>
                    <input
                      id="productCode"
                      type="text"
                      style={{
                        flex: 1,
                        padding: "4px",
                        border: "1px solid #F8F9FA",
                        borderRadius: "0px",
                        backgroundColor: "#F8F9FA",
                        fontFamily: "Inter, sans-serif",
                        fontWeight: 700,
                        fontSize: "16px",
                        color: "#171A1F",
                        width: "100%",
                        minWidth: 0,
                      }}
                      value={formData.ps_product_productcode || ""}
                      disabled
                    />
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      flex: 1,
                      mb: 2,
                      minWidth: 0,
                      width: "100%",
                      flexDirection: { xs: "column", md: "row" },
                      gap: { xs: 1, md: 0 },
                    }}
                  >
                    <label
                      htmlFor="dateUpdated"
                      style={{
                        width: "150px",
                        minWidth: "150px",
                        fontWeight: 400,
                        fontSize: "16px",
                        fontFamily: "Inter, sans-serif",
                      }}
                    >
                      Date updated :
                    </label>
                    <input
                      id="dateUpdated"
                      type="text"
                      style={{
                        flex: 1,
                        padding: "4px",
                        border: "1px solid #F8F9FA",
                        borderRadius: "0px",
                        backgroundColor: "#F8F9FA",
                        fontFamily: "Inter, sans-serif",
                        fontWeight: 400,
                        fontSize: "16px",
                        color: "#171A1F",
                        width: "100%",
                        minWidth: 0,
                      }}
                      value={
                        formData.updated_on
                          ? formData.updated_on.split("T")[0]
                          : ""
                      }
                      disabled
                    />
                  </Box>
                </Grid>

                {/* Left Column */}
                <Grid item xs={12} sm={6}>
                  {/* <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      marginBottom: "16px",
                      flexDirection: { xs: "column", sm: "row" },
                      width: "100%",
                      gap: { xs: 1, sm: 0 },
                    }}
                  >
                    {/* <label
                      htmlFor="count"
                      style={{
                        width: "150px",
                        fontWeight: 400,
                        fontSize: "16px",
                        fontFamily: "Inter, sans-serif",
                      }}
                    >
                      Count :
                    </label>
                    <input
                      id="count"
                      type="text"
                      style={{
                        flex: 1,
                        padding: "4px",
                        border: "1px solid #F8F9FA",
                        borderRadius: "0px",
                        backgroundColor: "#F8F9FA",
                        fontFamily: "Inter, sans-serif",
                        fontWeight: 400,
                        fontSize: "16px",
                        color: "#171A1F",
                        width: "100%",
                        minWidth: 0,
                      }}
                      value={formData.ps_product_count || ""}
                      disabled
                    /> 
                  </Box> */}
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      marginBottom: "16px",
                    }}
                  >
                    <label
                      htmlFor="construction"
                      style={{
                        width: "150px",
                        fontWeight: 400,
                        fontSize: "16px",
                        fontFamily: "Inter, sans-serif",
                      }}
                    >
                      Construction :
                    </label>
                    <input
                      id="construction"
                      type="text"
                      style={{
                        flex: 1,
                        padding: "4px",
                        border: "1px solid #F8F9FA",
                        borderRadius: "0px",
                        backgroundColor: "#F8F9FA",
                        fontFamily: "Inter, sans-serif",
                        fontWeight: 400,
                        fontSize: "16px",
                        color: "#171A1F",
                        width: "100%",
                        minWidth: 0,
                      }}
                      value={formData.ps_product_construction || ""}
                      disabled
                    />
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      marginBottom: "16px",
                    }}
                  >
                    <label
                      htmlFor="gsm"
                      style={{
                        width: "150px",
                        fontWeight: 400,
                        fontSize: "16px",
                        fontFamily: "Inter, sans-serif",
                      }}
                    >
                      GSM :
                    </label>
                    <input
                      id="gsm"
                      type="text"
                      style={{
                        flex: 1,
                        padding: "4px",
                        border: "1px solid #F8F9FA",
                        borderRadius: "0px",
                        backgroundColor: "#F8F9FA",
                        fontFamily: "Inter, sans-serif",
                        fontWeight: 400,
                        fontSize: "16px",
                        color: "#171A1F",
                        width: "100%",
                        minWidth: 0,
                      }}
                      value={formData.ps_product_gsm || ""}
                      disabled
                    />
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      marginBottom: "16px",
                    }}
                  >
                    <label
                      htmlFor="width"
                      style={{
                        width: "150px",
                        fontWeight: 400,
                        fontSize: "16px",
                        fontFamily: "Inter, sans-serif",
                      }}
                    >
                      Width :
                    </label>
                    <input
                      id="width"
                      type="text"
                      style={{
                        flex: 1,
                        padding: "4px",
                        border: "1px solid #F8F9FA",
                        borderRadius: "0px",
                        backgroundColor: "#F8F9FA",
                        fontFamily: "Inter, sans-serif",
                        fontWeight: 400,
                        fontSize: "16px",
                        color: "#171A1F",
                        width: "100%",
                        minWidth: 0,
                      }}
                      value={formData.ps_product_width || ""}
                      disabled
                    />
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      marginBottom: "16px",
                    }}
                  >
                    <label
                      htmlFor="updatedBy"
                      style={{
                        width: "150px",
                        fontWeight: 400,
                        fontSize: "16px",
                        fontFamily: "Inter, sans-serif",
                      }}
                    >
                      Updated by :
                    </label>
                    <input
                      id="updatedBy"
                      type="text"
                      style={{
                        flex: 1,
                        padding: "4px",
                        border: "1px solid #F8F9FA",
                        borderRadius: "0px",
                        backgroundColor: "#F8F9FA",
                        fontFamily: "Inter, sans-serif",
                        fontWeight: 400,
                        fontSize: "16px",
                        color: "#171A1F",
                        width: "100%",
                        minWidth: 0,
                      }}
                      value={formData.ps_product_updatedBy || ""}
                      disabled
                    />
                  </Box>
                </Grid>

                {/* Right Column */}
                <Grid item xs={12} sm={6}>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      marginBottom: "16px",
                      flexDirection: { xs: "column", sm: "row" },
                      width: "100%",
                      gap: { xs: 1, sm: 0 },
                    }}
                  >
                    <label
                      htmlFor="mill"
                      style={{
                        width: "150px",
                        fontWeight: 400,
                        fontSize: "16px",
                        fontFamily: "Inter, sans-serif",
                      }}
                    >
                      Mill :
                    </label>
                    <input
                      id="mill"
                      type="text"
                      style={{
                        flex: 1,
                        padding: "4px",
                        border: "1px solid #F8F9FA",
                        borderRadius: "0px",
                        backgroundColor: "#F8F9FA",
                        fontFamily: "Inter, sans-serif",
                        fontWeight: 400,
                        fontSize: "16px",
                        color: "#171A1F",
                        width: "100%",
                        minWidth: 0,
                      }}
                      value={formData.ps_product_mill || ""}
                      disabled
                    />
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      marginBottom: "16px",
                    }}
                  >
                    <label
                      htmlFor="inventory"
                      style={{
                        width: "150px",
                        fontWeight: 400,
                        fontSize: "16px",
                        fontFamily: "Inter, sans-serif",
                      }}
                    >
                      Inventory :
                    </label>
                    <input
                      id="inventory"
                      type="text"
                      style={{
                        flex: 1,
                        padding: "4px",
                        border: "1px solid #F8F9FA",
                        borderRadius: "0px",
                        backgroundColor: "#F8F9FA",
                        fontFamily: "Inter, sans-serif",
                        fontWeight: 400,
                        fontSize: "16px",
                        color: "#171A1F",
                        width: "100%",
                        minWidth: 0,
                      }}
                      value={formData.ps_product_netqty || ""}
                      disabled
                    />
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      marginBottom: "16px",
                    }}
                  >
                    <label
                      htmlFor="fabricPattern"
                      style={{
                        width: "150px",
                        fontWeight: 400,
                        fontSize: "16px",
                        fontFamily: "Inter, sans-serif",
                      }}
                    >
                      Fabric category :
                    </label>
                    <input
                      id="fabricPattern"
                      type="text"
                      style={{
                        flex: 1,
                        padding: "4px",
                        border: "1px solid #F8F9FA",
                        borderRadius: "0px",
                        backgroundColor: "#F8F9FA",
                        fontFamily: "Inter, sans-serif",
                        fontWeight: 400,
                        fontSize: "16px",
                        color: "#171A1F",
                        width: "100%",
                        minWidth: 0,
                      }}
                      value={formData.ps_product_cat || ""}
                      disabled
                    />
                  </Box>
                  {/* <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      marginBottom: "16px",
                    }}
                  >
                    <label
                      htmlFor="tags"
                      style={{
                        width: "150px",
                        fontWeight: 400,
                        fontSize: "16px",
                        fontFamily: "Inter, sans-serif",
                      }}
                    >
                      Tags :
                    </label>
                    <Box sx={{ flex: 1, display: "flex", flexWrap: "wrap", gap: 1, minHeight: 40, alignItems: "center", backgroundColor: "#F8F9FA", borderRadius: "0px", padding: "2px 0 2px 4px" }}>
                      {(formData.ps_product_tags3 || "")
                        .split(",")
                        .map((tag, idx) =>
                          tag.trim() ? (
                            <Chip
                              key={idx}
                              label={tag.trim()}
                              size="small"
                              sx={{
                                fontFamily: "Inter, sans-serif",
                                fontSize: "13px",
                                backgroundColor: "#FFF",
                                color: "#565E6D",
                                borderRadius: "50px",
                                border: "1px solid #565E6D",
                                padding: "5px",
                              }}
                            />
                          ) : null
                        )}
                    </Box>
                  </Box> */}
                  {/* <Button
                    onClick={handleProductSubmit}
                    sx={{
                      mt: 5,
                      fontFamily: "Inter, sans-serif",
                      borderRadius: "0px",
                      backgroundColor: "#565E6D",
                      color: "#ffffff",
                      "&:hover": {
                        backgroundColor: "#546e7a",
                      },
                    }}
                  >
                    Request modification
                  </Button> */}
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          {/* 2ND Part */}
          <Box sx={{ mt: 5, mb: 5, width: "100%" }}>
            {/* Tabs Section */}
            <Tabs
              value={selectedTab}
              onChange={handleTabChange}
              variant="fullWidth"
              textColor="inherit"
              TabIndicatorProps={{
                style: { display: "none" },
              }}
              sx={{
                minHeight: "35px",
                backgroundColor: "#F3F4F6",
                "& .MuiTabs-flexContainer": {
                  height: "35px",
                },
                "& .MuiTab-root": {
                  minHeight: "35px",
                  textAlign: "start",
                  color: "black",
                  fontWeight: "bold",
                  padding: "2px 6px",
                  borderRight: "3px solid #696969",
                  "&:last-of-type": { borderRight: "none" },
                  "&.Mui-selected": { backgroundColor: "#DEE1E6" },
                },
              }}
            >
              <Tab label="Fabric Images" />
              <Tab label="Garment Images" />
              <Tab label="Image Sizing" />
            </Tabs>

            {/* Tab Content */}
            <TabPanel value={selectedTab} index={0}>
              <Box display="flex" gap={2}>
                {/* Fabric Images */}
                {fabricImages.map((src, index) => (
                  <Box
                    key={index}
                    sx={{
                      width: 93,
                      height: 63,
                      backgroundColor: "#F3F4F6",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      border: "0px solid #ccc",
                      borderRadius: "0px",
                      position: "relative",
                    }}
                  >
                    <img
                      src={src}
                      alt={`Fabric ${index + 1}`}
                      width="100%"
                      height="100%"
                      style={{ display: "block" }}
                    />
                    <Box
                      sx={{
                        position: "absolute",
                        bottom: 8,
                        right: 8,
                      }}
                    >
                      <IconButton>
                        <VisibilityOffOutlinedIcon fontSize="small" />
                      </IconButton>
                    </Box>
                  </Box>
                ))}
              </Box>
            </TabPanel>
            <TabPanel value={selectedTab} index={1}>
              <Box display="flex" gap={2}>
                {/* Garment Images */}
                {garmentImages.map((src, index) => (
                  <Box
                    key={index}
                    sx={{
                      width: 93,
                      height: 63,
                      backgroundColor: "#F3F4F6",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      border: "0px solid #ccc",
                      borderRadius: "0px",
                      position: "relative",
                    }}
                  >
                    <img
                      src={src}
                      alt={`Garment ${index + 1}`}
                      width="100%"
                      height="100%"
                      style={{ display: "block" }}
                    />
                    <Box
                      sx={{
                        position: "absolute",
                        bottom: 8,
                        right: 8,
                      }}
                    >
                      <IconButton>
                        <VisibilityOffOutlinedIcon fontSize="small" />
                      </IconButton>
                    </Box>
                  </Box>
                ))}
              </Box>
            </TabPanel>
            <TabPanel value={selectedTab} index={2}>
              <Box display="flex" gap={2}>
                {/* Image Sizing */}
                {imageSizing.map((src, index) => (
                  <Box
                    key={index}
                    sx={{
                      width: 93,
                      height: 63,
                      backgroundColor: "#F3F4F6",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      border: "0px solid #ccc",
                      borderRadius: "0px",
                      position: "relative",
                    }}
                  >
                    <img
                      src={src}
                      alt={`Size ${index + 1}`}
                      width="100%"
                      height="100%"
                      style={{ display: "block" }}
                    />
                  </Box>
                ))}
              </Box>
            </TabPanel>

            {/* Load Custom Presets Button */}
            {/* <Button
                        fullWidth
                        sx={{
                        padding: 1,
                        borderRadius: "0px",
                        backgroundColor: "#DEE1E6", 
                        color: "black",
                        fontWeight: "bold",
                        "&:hover": {
                            backgroundColor: "#b1b4b6", 
                        },
                        }}
                    >
                        Load Custom Presets
                    </Button> */}
          </Box>

          {/* 3RD Part */}
          <DetailDropdowns />

          {/* 4TH Part */}
          <Box
            sx={{
              mt: 5,
              display: "flex",
              flexDirection: "column",
              backgroundColor: "#F3F4F6",
              padding: 3,
              position: "sticky",
              top: 0,
              zIndex: 1000,
            }}
          >
            <Typography
              variant="h7"
              sx={{
                fontWeight: 700,
                fontSize: "16px",
                fontFamily: "Inter, sans-serif",
                color: "#323842",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              Product name
              <IconButton onClick={handleToggleEdit}>
                <EditOutlinedIcon />
              </IconButton>
            </Typography>
            <TextField
              variant="standard"
              placeholder="Enter product name"
              fullWidth
              sx={{
                mb: 3,
                backgroundColor: isEditing ? "white" : "#F3F4F6",
                padding: isEditing ? "5px 0px" : 0,
                "& .MuiInputBase-input": {
                  color: "#000",
                  padding: isEditing ? "6px 8px" : 0,
                },
                "& .MuiInput-underline:before": {
                  borderBottom: "none !important",
                },
                "& .MuiInput-underline:after": {
                  borderBottom: "none !important",
                },
                "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                  borderBottom: "none !important",
                },
              }}
              value={formData.ps_product_prodname || ""}
              onChange={(e) =>
                handleDateChange("ps_product_prodname", e.target.value)
              }
              disabled={!isEditing}
            />
            <Typography
              variant="body1"
              sx={{
                fontWeight: 700,
                fontSize: "16px",
                fontFamily: "Inter, sans-serif",
                color: "#323842",
              }}
            >
              Description
            </Typography>
            <Box
              sx={{
                display: "flex",
                alignItems: "flex-end",
                justifyContent: "space-between",
                width: "100%",
              }}
            >
              <TextField
                variant="standard"
                placeholder="Enter product description"
                multiline
                minRows={4}
                sx={{
                  backgroundColor: isEditing ? "white" : "#F3F4F6",
                  flex: 1,
                  padding: isEditing ? "8px 12px" : 0,
                  "& .MuiInputBase-input": {
                    color: "#000",
                    padding: isEditing ? "8px 0" : 0,
                  },
                  "& .MuiInput-underline:before": {
                    borderBottom: "none !important",
                  },
                  "& .MuiInput-underline:after": {
                    borderBottom: "none !important",
                  },
                  "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                    borderBottom: "none !important",
                  },
                }}
                value={formData.ps_product_productdesc || ""}
                onChange={(e) =>
                  handleDateChange("ps_product_productdesc", e.target.value)
                }
                disabled={!isEditing}
              />
            </Box>
            {/* Save Changes Button */}
            {isEditing && (
              <div style={{ textAlign: "center", marginTop: "20px" }}>
                <Button
                  onClick={handleProductSubmit}
                  sx={{
                    ml: 5,
                    backgroundColor: "#565E6D",
                    color: "#fff",
                    "&:hover": { backgroundColor: "#546e7a" },
                    borderRadius: "0px",
                  }}
                >
                  Save Changes
                </Button>
              </div>
            )}
          </Box>
        </Box>
      )}
    </Box>
  );
}
